import { render, staticRenderFns } from "./PortalAttend.vue?vue&type=template&id=e55ef7fc&lang=pug"
import script from "./PortalAttend.vue?vue&type=script&lang=js"
export * from "./PortalAttend.vue?vue&type=script&lang=js"
import style0 from "./PortalAttend.vue?vue&type=style&index=0&id=e55ef7fc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports